import React from "react";
import classNames from "classnames";
import { TTeeOnActivationStep } from "../teeOnPaymentsTypes";
import "./activationSteps.scss";

interface IStepperItem {
  id: TTeeOnActivationStep;
  title: string;
  description: string;
}

interface IActivationStepsProps {
  currentStep: TTeeOnActivationStep;
  completedSteps: number[];
  steps: IStepperItem[];
  onStepClick: (step: TTeeOnActivationStep) => void;
}

export default function ActivationSteps(props: IActivationStepsProps) {
  const { currentStep, completedSteps, steps, onStepClick } = props;

  return (
    <div className="tee-on-payments-activation-steps tee-on-payments-activation-steps_sticky">
      {steps.map((step, index) => {
        const isCurrent = currentStep === step.id;
        const isComplete = completedSteps.includes(step.id);
        const isLast = index === steps.length - 1;

        return (
          <div
            className="tee-on-payments-activation-steps-item"
            key={step.id}
            onClick={() => onStepClick(step.id)}
            aria-current={isCurrent ? "step" : undefined}
          >
            <div className="tee-on-payments-activation-steps-icon-wrapper">
              <div
                className={classNames("tee-on-payments-activation-steps-icon", {
                  "tee-on-payments-activation-steps-icon_complete": isComplete,
                  "tee-on-payments-activation-steps-icon_current": isCurrent,
                })}
              >
                {isComplete ? (
                <img style={{ width: "12px", height: "12px" }} src="/public/images/icons/check.svg" alt="check.svg" />
                ) : null}
              </div>
              {!isLast ? (
                <div
                  className={classNames("tee-on-payments-activation-steps-connector", {
                    "tee-on-payments-activation-steps-connector_complete": isComplete,
                  })}
                />
              ) : null}
            </div>

            <div className="tee-on-payments-activation-steps-content">
              <p className="text-sm text-semibold text-primary-700">{step.title}</p>
              <p className="text-sm text-primary-600 text-regular">{step.description}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
}
